// App-side delegate for `@heidi/templates/data` (D2.7, ARCFE-1046).
// The desktop-readiness read and the error toast stayed; the query body, the
// sort, the offline cache fallback and the module-scope invalidator moved.
import { toast } from '@heidi/design-system/toast';
import { GET_CONSULT_NOTE_TEMPLATES } from '@heidi/templates/contracts';
import {
  invalidateNoteTemplates,
  useQueryConsultNoteTemplates as useQueryConsultNoteTemplatesCore,
} from '@heidi/templates/data';
import type { AxiosError } from 'axios';
import { useCallback } from 'react';
import { useIsDesktopOnlineReady } from '../desktop/useIsDesktopOnlineReady';

export { GET_CONSULT_NOTE_TEMPLATES, invalidateNoteTemplates };

export function useQueryConsultNoteTemplates() {
  const isDesktopOnlineReady = useIsDesktopOnlineReady();

  const onRequestError = useCallback((error: AxiosError) => {
    toast({
      tone: 'destructive',
      title: 'Error',
      description: error.message,
    });
  }, []);

  return useQueryConsultNoteTemplatesCore(isDesktopOnlineReady, onRequestError);
}
